import { testevalConstants } from '../constants';
import { RequestService,FunctionService } from '../services';
export const testevalActions = {
    getTest,
    getDetailTest,
    submitAnswer,
    storebeforeSave,
    getstorejson,
    fakerefresh,
    initDetail
};
function initDetail(){
    return dispatch => {
        dispatch(FunctionService.request(testevalConstants.REMOVE_DETAIL_TEST_REQUEST))
    }
}
function getTest(){
    return dispatch => {
        dispatch(FunctionService.request(testevalConstants.GET_TEST_REQUEST))
        RequestService.GetRequest('evaluator/test/list',true)
        .then(res=>{
            dispatch(FunctionService.succes(res.data,testevalConstants.GET_TEST_SUCCESS))
        })
        .catch(err=>{
            dispatch(FunctionService.failure(err.response,testevalConstants.GET_TEST_FAILURE))
        })
    }
}
function getDetailTest(idtest){
    return dispatch => {
        dispatch(FunctionService.request(testevalConstants.GET_DETAIL_TEST_REQUEST))
        RequestService.GetRequest('evaluator/evaluation/'+idtest,true)
        .then(res=>{
            dispatch(FunctionService.succes(res.data,testevalConstants.GET_DETAIL_TEST_SUCCESS))
        })
        .catch(err=>{
            dispatch(FunctionService.failure(err.response,testevalConstants.GET_DETAIL_TEST_FAILURE))
        })
    }
}
function submitAnswer(answer){
    return dispatch => {
        dispatch(FunctionService.request(testevalConstants.SUBMIT_TEST_REQUEST))
        RequestService.PostRequest("evaluator/evaluation/submit",answer,true)
        .then(res=>{
            dispatch(FunctionService.succes(res.data,testevalConstants.SUBMIT_TEST_SUCCESS))
        })
        .catch(err=>{
            dispatch(FunctionService.failure(err.response,testevalConstants.SUBMIT_TEST_FAILURE))
        })
    }
}

function storebeforeSave(filejson){
    // console.log('storebeforesave : ',filejson)
    return dispatch => {
        // dispatch(FunctionService.request(testevalConstants.SUBMIT_TEST_REQUEST))
        RequestService.PostRequest("evaluator/evaluation/storebeforesave",filejson,true)
        .then(res=>{
            console.log('Answers are saved ')
            // dispatch(FunctionService.succes(res.data,testevalConstants.SUBMIT_TEST_SUCCESS))
        })
        .catch(err=>{
            // dispatch(FunctionService.failure(err.response,testevalConstants.SUBMIT_TEST_FAILURE))
        })
    }
}
function getstorejson(filejson){
    return dispatch => {
        RequestService.PostRequest("evaluator/evaluation/getstorejson",filejson,true)
        .then(res=>{
        })
        .catch(err=>{
        })
    }
}
function fakerefresh(){
    return dispatch => {
        dispatch(FunctionService.request(testevalConstants.SUBMIT_TEST_REQUEST_START))
        setTimeout(() => {
            dispatch(FunctionService.request(testevalConstants.SUBMIT_TEST_REQUEST_END))
        }, 2000);
    }
}